export default class SearcherDestination {
    constructor() {
        this.eventDelegation();
        this.activeFilters = {};
        this.initializeFilters();
    }

    eventDelegation() {
        this.doSearchDestination();
        this.setDestinationInputText();
    }

    doSearchDestination() {
        let destinations = $("[data-destination-option='true']");
        let allDestinations = $("[data-all-destinations='true']");
        let closeToMe = $("[data-close-to-me='true']");
        const selectAllOption = $('[data-destination="all"]');

        let newClass = 'active-item';
        destinations.on("click", (event) => {
            let currentElement = event.currentTarget;
            if (currentElement.hasAttribute("data-all-destinations") || currentElement.hasAttribute("data-close-to-me")) {
                destinations.removeClass(newClass);
            } else {
                allDestinations.removeClass(newClass);
                closeToMe.removeClass(newClass);
            }

            if (currentElement.classList.contains(newClass)) {
                currentElement.classList.remove(newClass);
            } else {
                currentElement.classList.add(newClass);
                const value = currentElement.getAttribute('value');
                const dataDestination = currentElement.getAttribute('data-destination');

                if (dataDestination) {
                    $('[value="' + dataDestination + '"]').each(function (index, element) {
                        if (element.classList.contains(newClass) && element !== currentElement) {
                            element.classList.remove(newClass);
                        }
                    });
                }

                if (value) {
                    $('[data-destination="' + value + '"]').each(function (index, element) {
                        if (element.classList.contains(newClass) && element !== currentElement) {
                            element.classList.remove(newClass);
                        }
                    });
                }
            }

            const selectedItems = $('[data-category-id].active-item');

            if (currentElement.getAttribute('data-destination') === 'all') {
                selectedItems.removeClass('active-item');
            }

            if (selectedItems.length > 0 && currentElement.getAttribute('data-destination') !== 'all') {
                selectAllOption.removeClass(newClass);
            } else {
                selectAllOption.addClass(newClass);
            }

            this.setDestinationInputText();
        });

        $('[data-dropdown-menu="destinations"]').on('click', function (event) {
            event.stopPropagation();
            event.stopImmediatePropagation();
            event.preventDefault();
            if ($(event.target).data('dropdown-button') === true ||
                $(event.target).closest('[data-dropdown-button="true"]').length === true) {
                $('[data-dropdown-menu="destinations"]').dropdown('toggle');
            }
        });

        $('.searcher-submit-button').on("click", () => {
            let selectedIds = this.loadSelectedDestinationsIds();
            jQuery.each(selectedIds, function () {
                let destinationInputCopy = $('#destination-input-template').contents().clone();
                destinationInputCopy.attr('value', this);
                if ($('.searcher-input-container').find('[value="' + this + '"].destination-input').length === 0) {
                    destinationInputCopy.appendTo('.searcher-input-container');
                }
            });
        });
    }

    loadSelectedDestinationsIds() {
        let selectedDestinations = $('.destination-modal').find('.destination-zone.active-item');
        return selectedDestinations.map(function () {
            return $(this).attr('value');
        });
    }

    setDestinationInputText() {
        let allDestinations = $("[data-all-destinations='true']:not([data-parent=\"selected-tags\"])");
        let optionsSelected = $('.destination-modal').find('.active-item:not([data-type="category"], [data-all-destinations="true"])');
        const destinationTextInputs = document.querySelectorAll('[data-input="destination-text"], #destination-text');
        if (optionsSelected.length > 1) {
            let destinationsInputText = "";
            jQuery.each(optionsSelected, function (index) {
                destinationsInputText += this.textContent.trim();
                if (index < optionsSelected.length - 1) {
                    destinationsInputText += ", ";
                }
            });
            destinationTextInputs.forEach(input => { input.textContent = destinationsInputText });
            $('[data-container="selected-tags-list"]').text(destinationsInputText);
            $('[data-parent="selected-tags"]').removeClass('d-none');
        } else if (optionsSelected.length > 0) {
            destinationTextInputs.forEach(input => { input.textContent = optionsSelected.text() });
            $('[data-container="selected-tags-list"]').text(optionsSelected.text());
            $('[data-parent="selected-tags"]').removeClass('d-none');
        } else {
            destinationTextInputs.forEach(input => { input.textContent = allDestinations.text() });
            $('[data-container="selected-tags-list"]').text(allDestinations.text());
            $('[data-parent="selected-tags"]').addClass('d-none');
            allDestinations.addClass('active-item');
        }
    }

    setDestinations(destinations) {
        $('[data-destination-option=true]').each(function () {
            $(this).removeClass("active-item");
        });
        let arrayDestinations = destinations.split(';');
        $.each(arrayDestinations, function (index, id) {
            $('[data-destination-option=true]').each(function () {
                if ($(this).attr('value') == id) {
                    $(this).addClass("active-item");
                }
            })
        });
        this.setDestinationInputText();
    }

    initializeFilters() {
        const allDestinationsFilter = [];
        const allActiveFilters = document.querySelectorAll('[data-element="searcher-destination-tag"].active-item');
        document.querySelectorAll('[data-action="destination-searcher-filter"]').forEach((element) => {
            let categoryType = element.dataset.categoryType;
            if (categoryType) {
                let destinations = document.querySelectorAll('[data-element="searcher-destination-tag"][data-destination="' + categoryType + '"]');
                if (destinations.length < 3 && categoryType !== "all") {
                    element.remove();
                    destinations.forEach((destination) => {
                        destination.remove();
                    });
                    return;
                } else {
                    allDestinationsFilter.push(element);
                    if (destinations.length === 1 && allActiveFilters.length === 0) {
                        destinations[0].classList.add('active-item');
                    }
                }
            }

            element.addEventListener('click', (event) => {
                event.currentTarget.classList.add('active-item');

                document.querySelectorAll('[data-action="destination-searcher-filter"]').forEach((element) => {
                    if (element !== event.currentTarget) {
                        element.classList.remove('active-item');
                    }
                });

                this.activeFilters[event.currentTarget] =
                    (element) => {
                        return !event.currentTarget.dataset.categoryType || element.dataset.destination == event.currentTarget.dataset.categoryType;
                    }

                this.filterDestinations();
            });

        });

        if (allDestinationsFilter.length === 1) {
            allDestinationsFilter[0].classList.add('active-item');
            this.activeFilters[allDestinationsFilter[0]] = (element) => {
                return !element.dataset.destination || element.dataset.destination === "";
            };
        }

        const activeFilter = document.querySelector('[data-action="destination-searcher-filter"].active-item');
        if (activeFilter) {
            activeFilter.click();
        }
    }

    filterDestinations() {
        const destinations = document.querySelectorAll('[data-element="searcher-destination-tag"]');
        const areFiltersActive = Object.keys(this.activeFilters).length > 0;
        destinations.forEach((destination) => {
            const visible = areFiltersActive ? Object.values(this.activeFilters).some((filter) => filter(destination)) : true;
            destination.classList.toggle('d-none', !visible);
        });

        const activeFilter = document.querySelector('[data-action="destination-searcher-filter"].active-item');
        if (activeFilter.dataset.categoryType === "" ) {
            const destinationsAllOptions = document.querySelectorAll('[data-show-all="false"]');
            destinationsAllOptions.forEach((destination) => {
                destination.classList.add('d-none');
            });
        }

    }
}
